import { configValues } from 'src/config';

export const alliances = () => [
  {
    title: 'Franchise Council of Australia',
    description:
      'The Franchise Council of Australia is the peak body for the $184billion franchise business segment, which includes 1,344 networks, with 98,000+ individual franchised outlets, employing more than 598,000 people.',
    url: 'https://www.franchise.org.au/',
    imageUrl: `${configValues.IMAGE_SERVER_BASE}/content/fca.png`,
  },
  {
    title: 'Franchise Relationships Institute',
    description:
      "FRI are widely regarded as the worlds's leading experts in the psychology of the franchise relationship, helping franchisors and franchisees to foster profitable partnerships.",
    url: 'https://www.franchiserelationships.com/',
    imageUrl: `${configValues.IMAGE_SERVER_BASE}/content/fri.png`,
  },
  {
    title: 'Norton Rose Fulbright',
    description:
      'Norton Rose Fulbright are a preeminent franchising legal practice with lawyers who are recognized as being superior in industry and regulatory knowledge.',
    url: 'https://www.nortonrosefulbright.com/en-au',
    imageUrl: `${configValues.IMAGE_SERVER_BASE}/content/nrf.png`,
  },
];
